module.exports = __webpack_public_path__ + "img/icono-educativos.639fb229.svg";